import { BaseData } from "src/app/shared/models/base-data";

export class AccountDetailData extends BaseData {

}